import React, { useRef } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import RowComponent from './RowComponent';
import OpenShiftTableRow from './OpenShift/OpenShiftTableRow';
import VTOTableRow from './VTO/VTOTableRow';

import styledConfirm from '../../../UserManagement/components/Header/styled';
import Modal from 'components/GeneralComponents/Modal';
import LinkUserComponent from './LinkUserComponent';
import AddUnregisteredUserContainer from 'pages/UnregisteredUser/AddUnregisteredUserContainer';
import './TableComponent.scss';

import { Mixpanel } from 'helpers/Mixpanel';
import  SortableTableHeaderComponent from 'pages/ScheduleTab/SortableTableHeaderComponent';
import utils from 'pages/ScheduleCalendar/duck/utils';
import service from 'pages/ScheduleCalendar/duck/service';
import ShiftDetailModals from './ShiftDetail/ShiftDetailModals';

const LoadingLayer = ({ loading }) => {
  return (
    <div className={`shyft-table--loading-layer ${loading ? 'show' : ''}`}>
      <img src="/loader.gif" alt="Loading gif" />
    </div>
  );
};

class TableComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      debug: true,
      unRegisteredUsers: [],
      showLinkScheduleModal: false,
      showAddUnregUserModal: false,
      sortByDayOfWeek: 0,
      stepAdded: false,
    };
    this._isMounted = false;
    this.shiftModalRef = React.createRef();
  }

  selectedUnregisteredUserToLink = (user) => {
    this.setState({ showLinkScheduleModal: true });
    this.userToLink = user;
  };

  cancelLinkUser = () => {
    this.setState({ showLinkScheduleModal: false });
  }

  selectedDateToAddShift = (user, date, creationType) => {
    this.shiftModalRef.current?.openShiftDetail(null, date, user, creationType);
  }

  selectedShiftToViewDetail = (shift, date) => {
    this.shiftModalRef.current?.openShiftDetail(shift, date);
  }

  prepareToDeleteShift = (scheduleId, locationId, revokeChildCard) => {
    this.shiftModalRef.current?.prepareToDeleteShift(scheduleId, locationId, revokeChildCard);
  }

  prepareToApproveApplicant = (shift, applicant) => {
    this.shiftModalRef.current?.prepareToApproveApplicant(shift, applicant);
  }

  prepareToDenyApplicant = (shift, applicant) => {
    this.shiftModalRef.current?.prepareToDenyApplicant(shift, applicant);
  }

  handleAddTeamMemberClick = () => {
    this.setState({ showAddUnregUserModal: true });
    Mixpanel.track('Clicked add user on schedule');
  }

  handleCloseAddTeamModal = () => {
    this.setState({ showAddUnregUserModal: false });
  }

  handleSortableHeaderClick = (sortByDay) => {
    this.setState({ sortByDayOfWeek: sortByDay });
  };

  keyForUser = (user) => {
    if (!user) return 'null';
    return user.id ?? user.unregistered_user_id;
  }

  choseShiftToCopy = (shift) => {
    const { notifyHeaderOfShiftPasting } = this.props;
    this.setState({ shiftToCopy: shift, isCopyingShift: true });
    notifyHeaderOfShiftPasting(true, shift);
  }

  render() {
    const {
      handleTooltipShow, handleTooltipHide, isCopyingShift, shiftToCopy,
      shouldShowAddMemberButton, handleShowSMSInviteModal, shifts, loading, allUsers, locationSettings, channels, locationId, locationData,
      rangeStart, rangeEnd, linkUnregisteredUser, unregisteredUsers, openShiftHoursResult, addStep, enableVTO, vtoHoursResult
    } = this.props;
    const { sortByDayOfWeek, showLinkScheduleModal, showAddUnregUserModal, showSendEmailModal } = this.state;

    const addTeamMemberText = (
      <FormattedMessage id="ScheduleCalendarComponent.addTeamMember" defaultMessage="+ Add Team Member" />
    );

    const sortedUsers = utils.sortUsersWithShiftOrder(rangeStart, sortByDayOfWeek, shifts, allUsers, unregisteredUsers);
    const matrix = service.shiftMatrixMappedToUsers(shifts, sortedUsers, rangeStart, locationSettings.cfg__inventory_show);
    const shouldShowOpenShiftUI = locationSettings.cfg__shift__post_open_shift == true;

    // console.log("Matrix: ", matrix);

    const sortedRows = sortedUsers.map((user, index) => {
      const userShiftsForTheWeek = service.getUserWeeklyShiftsFromMatrix(user, matrix)
      return (rangeStart && user &&
        <RowComponent
          key={this.keyForUser(user)}
          userShiftsForTheWeek={userShiftsForTheWeek}
          user={user}
          allUsers={allUsers}
          locationId={locationId}
          weekRangeStart={rangeStart}
          weekRangeEnd={rangeEnd}
          selectedUnregisteredUserToLink={this.selectedUnregisteredUserToLink}
          selectedDateToAddShift={this.selectedDateToAddShift}
          selectedShiftToViewDetail={this.selectedShiftToViewDetail}
          handleShowSMSInviteModal={handleShowSMSInviteModal}
          isCopyingShift={isCopyingShift}
          shiftToCopy={shiftToCopy}
          handleTooltipHide={handleTooltipHide}
          handleTooltipShow={handleTooltipShow}
          addStep={addStep}
          rowIndex={index}
          channels={channels}
        />
      );
    });

    return (
      <section className="calendar-table__wrap">
        <LoadingLayer loading={loading} />
        <table className={`calendar-table ${loading ? 'loading' : ''}`}>
          <SortableTableHeaderComponent
            shouldShowOpenShiftUI={shouldShowOpenShiftUI}
            rangeStart={rangeStart}
            rangeEnd={rangeEnd}
            handleSortableHeaderClick={this.handleSortableHeaderClick}
            sortByDayOfWeek={sortByDayOfWeek}
          />

          {rangeStart && shouldShowOpenShiftUI && (
            <OpenShiftTableRow
              shifts={shifts}
              locationSettings={locationSettings}
              weekRangeStart={rangeStart}
              weekRangeEnd={rangeEnd}
              handleTooltipHide={handleTooltipHide}
              handleTooltipShow={handleTooltipShow}
              selectedDateToAddShift={this.selectedDateToAddShift}
              selectedShiftToViewDetail={this.selectedShiftToViewDetail}
              channels={channels}
              locationData={locationData}
              openShiftHoursResult={openShiftHoursResult}
              isCopyingShift={isCopyingShift}
              shiftToCopy={shiftToCopy}
            />
          )}

          {rangeStart && enableVTO && (
            <VTOTableRow
              shifts={shifts}
              locationSettings={locationSettings}
              weekRangeStart={rangeStart}
              weekRangeEnd={rangeEnd}
              handleTooltipHide={handleTooltipHide}
              handleTooltipShow={handleTooltipShow}
              selectedDateToAddShift={this.selectedDateToAddShift}
              selectedShiftToViewDetail={this.selectedShiftToViewDetail}
              channels={channels}
              locationData={locationData}
              vtoHoursResult={vtoHoursResult}
              isCopyingShift={isCopyingShift}
              shiftToCopy={shiftToCopy}
            />
          )}

          {shouldShowOpenShiftUI && (
            <tbody className='filler-row'>
              <tr className="calendar-row">
                <td colSpan={8}>
                  <label className='filler-label fs14'>Team Members</label>
                </td>
              </tr>
            </tbody>
          )}

          <tbody>{sortedRows}</tbody>
          <tbody>
            <tr>
              <td>
                {shouldShowAddMemberButton && (
                  <button className='inv-btn averta-semibold' data-id="Deefeature1" onClick={this.handleAddTeamMemberClick}>
                    {addTeamMemberText}
                  </button>
                )}
              </td>
            </tr>
          </tbody>
        </table>

        {showLinkScheduleModal && (
          <Modal>
            <LinkUserComponent
              allUsers={allUsers}
              shifts={shifts}
              rangeStart={rangeStart}
              rangeEnd={rangeEnd}
              unregisteredUserToLink={this.userToLink}
              cancelModal={this.cancelLinkUser}
              linkUnregisteredUser={linkUnregisteredUser}
            />
          </Modal>
        )}

        <ShiftDetailModals
          ref={this.shiftModalRef}
          matrix={matrix}
          rangeStart={rangeStart}
          locationSettings={locationSettings}
          allUsers={allUsers}
                      prepareToCopyShift={this.choseShiftToCopy}
            locationId={locationId}
          />

        {showAddUnregUserModal && (
          <Modal>
            <AddUnregisteredUserContainer
              locationId={locationId}
              handleCloseAddTeamModal={this.handleCloseAddTeamModal}
              locationData={locationData}
            />
          </Modal>
        )}

        <styledConfirm.Overlay
          display={showLinkScheduleModal || showAddUnregUserModal || showSendEmailModal ? 'block' : 'none'}
        />
      </section>
    );
  }
}

export default injectIntl(TableComponent);
